import { IApplicationState } from '../../types/redux';

export const selectCpdNewIndicatorVisible = (state: IApplicationState) => {
  const isAvailable = state.cpd?.isAvailable;

  if (!isAvailable) {
    return false;
  }

  return state.cpd.newIndicatorVisible;
};
